import React from 'react';
import * as constant from './constants';
import Button from './../Button';
import ImageButton from './../Button/ImageButton';
import FormGroup from './../FormGroup';
import Keyboard from './../Keyboard/Keyboard';
import { LocalTranslations } from '../../requests/apa/local';
import translatesJson from './Add.translates.json';import UtilsProfile from '../../utils/Profile';
import logger from 'src/utils/logger/logger';
import Utils from '../../utils/Utils';
import {
  trackProfilesCreateSubmitted,
} from '../../services/datadog/profile';

const localTranslations = new LocalTranslations(translatesJson);


export const Add = ({ props }) => {

  const inputName = 'firstName';
  const inputImage = 'userImage';
  const inputNameField = UtilsProfile.getField(props.fields, inputName);
  const inputImageField = UtilsProfile.getField(props.fields, inputImage);
  const imgSrc = UtilsProfile.changeProtocolURLImage(inputImageField.value)

  if (props.defaultFocus) {
    UtilsProfile.setFocus('.container.add_profile .row.input .focusable');
  }

  return (
    <div className='container add_profile'>
      <div className='col left'>
        <div className='row'></div>
        <div className='row keyboard'>
          <Keyboard
            currentValue={inputNameField.value}
            onClick={(text) => {
              props.setTextValue(text);
            }}/>
        </div>
      </div>
      <div className='col right'>
        <div className='row'></div>
        <div className='row title'>
          <span>{localTranslations.get('add_profile_title', 'Agregar perfil')}</span>
        </div>
        <div className='row avatar-option'>
          <ImageButton order={['text']} className='image'
            imgSrc={Utils.adaptImageProtocol(inputImageField.value)}
            focusable={false}
          />
          <Button order={['text']} className='button' text={localTranslations.get('change_profile_picture_btn', 'Cambiar imagen')}
            onClick={() => {
              props.sendMetricProfile({
                event: constant.METRIC_EVENT,
                category: constant.METRIC_CATEGORY_START,
                action: constant.METRIC_ACTION_PROFILE,
                label: constant.METRIC_LABEL_CHANGEIMAGE,
              });
              props.onSetAction(constant.SELECT_PROFILE);
            }} />
        </div>
        <div className='row error'>
          <span className='error'>{inputImageField.error}</span>
        </div>
        <div className='row input'>
          <FormGroup
            id={inputName}
            value={inputNameField.value}
            error={inputNameField.hasError}
            message={inputNameField.error}
            placeholder={localTranslations.get('enter_profile_name_placeholder', 'Ingresa Nombre')}
            onFocused={() => {
              //setCurrentKey(inputName);
            }} />
        </div>
        <div className='row button'>
          <Button order={['text']} className='button' text={localTranslations.get('cancel_add_profile_btn', 'Cancelar')}
            onClick={() => {
              props.onSetAction(constant.START)
            }} />
          <Button order={['text']} className='button' text={localTranslations.get('save_profile_btn', 'Aceptar')}
            onClick={() => {
              if (UtilsProfile.validateForm(props.fields, props.onFieldError)) {

                const params = {
                  firstname: inputNameField.value,
                  user_image: imgSrc
                };

                trackProfilesCreateSubmitted(params);
                props.createProfile(params).then((response) => {

                  if (response.data) {
                    props.sendMetricProfile({
                      event: constant.METRIC_EVENT,
                      category: constant.METRIC_CATEGORY_START,
                      action: constant.METRIC_ACTION_PROFILE,
                      label: constant.METRIC_LABEL_NEWPROFILESUCCESSFUL,
                    });
                    props.onSetAction(constant.START)
                  }
                }).catch((err) => {
                  logger.error('Error al agregar Perfil', err);
                });
              }
            }}/>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Profile/Add.jsx